import React from 'react';
import { CheckIcon, FolderOpenIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { instantAccessItems, usageSteps } from '../data/instantAccess';
export function InstantAccessSection() {
  return <section aria-labelledby="instant-title" className="bg-white px-4 py-20 md:py-28" data-id="element-148" data-mp="1mfu80mq37yjy">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-149" data-mp="1hnu1ucjfc9ex">
        <p className="mb-4 text-xs font-extrabold uppercase tracking-[0.18em] text-brand-teal-ink" data-id="element-150" data-mp="1hm98urcrcyj6">
          DANS LA COLLECTION
        </p>
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-brand-gold text-brand-navy" data-id="element-151" data-mp="1reoohi0l1b0w">
          <FolderOpenIcon className="h-7 w-7" aria-hidden="true" data-id="element-152" data-mp="25d4wrde3f9l5" />
        </div>
        <h2 id="instant-title" className="mb-12 text-3xl font-extrabold tracking-tight text-brand-navy md:text-4xl" data-id="element-153" data-mp="20fmwebe562or">
          Tout votre matériel, au même endroit.
        </h2>
        <ul className="space-y-3 text-left" data-id="element-154" data-mp="612f88p14pa4">
          {instantAccessItems.map(item => <li key={item} className="flex items-center gap-4 rounded-2xl border border-brand-line bg-white p-5" data-id="element-155" data-mp="2n1x6fltxu3vo">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-teal-ink text-white" data-id="element-156" data-mp="2rzypi6rd6375">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-157" data-mp="2wy9y6e5xa7ns" />
              </span>
              <span className="text-sm font-semibold leading-snug md:text-base" data-id="element-158" data-mp="31rmiic3kjsaq">{item}</span>
            </li>)}
        </ul>

        <div className="mt-14 rounded-3xl bg-brand-ivory px-5 py-8 text-left md:px-8" data-id="element-159" data-mp="35u94hwdk6j00">
          <h3 className="text-center text-xl font-extrabold tracking-tight text-brand-navy md:text-2xl" data-id="element-160" data-mp="3aper6xesc1p5">
            Comment l’utiliser pour une séance
          </h3>
          <ol className="mt-8 grid gap-6 md:grid-cols-3 md:gap-6" data-id="element-161" data-mp="3koe10jbae3dq">
            {usageSteps.map(({
            title,
            description
          }, index) => <li key={title} className="flex gap-4 md:flex-col md:gap-0" data-id="element-162" data-mp="1le5ua03s5ut2" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand-navy text-sm font-bold text-white" data-id="element-163" data-mp="1qc7faqkro476">
                  {index + 1}
                </span>
                <div className="md:mt-4" data-id="element-164" data-mp="1dcx5tcmqid1m">
                  <h4 className="font-bold leading-snug text-brand-navy" data-id="element-165" data-mp="1ddzx3lnyyhi2">
                    <span className="sr-only" data-id="element-166" data-mp="1sa7fcgfth8up">{index + 1}. </span>
                    {title}
                  </h4>
                  <p className="mt-1.5 text-sm leading-relaxed text-slate-600" data-id="element-167" data-mp="1nbw1zvqbcg7q">{description}</p>
                </div>
              </li>)}
          </ol>
        </div>

        <p className="mt-10 text-2xl font-bold italic text-brand-teal" data-id="element-168" data-mp="1w9yasxgagd5k">
          Une base de travail que vous pouvez faire vôtre.
        </p>
      </Reveal>
    </section>;
}